import React from 'react';

import { TextField } from '../TextField';
import styles from './NotesField.module.css';

interface NotesFieldProps {
    errorMessage?: string;
    value?: string | null;
    placeholder?: string;
    onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

export const NotesField = ({ value, placeholder, errorMessage, onChange }: NotesFieldProps) => {
    return (
        <TextField
            className={styles.notes}
            fullWidth
            errorMessage={errorMessage}
            value={value}
            multiline
            maxRows={48}
            minRows={12}
            placeholder={placeholder ?? 'Add notes here...'}
            onChange={onChange}
        />
    );
};
